<script setup>
import { IconMessage, IconMessageFilled } from '@tabler/icons-vue';
import { ref } from 'vue';

const props = defineProps({
    comments: {
        type: [Object, null],
        required: false,
    },
});

const showButton = ref(props.comments.show_link);
const hasComments = ref(props.comments.comments_count);

defineOptions({
    name: 'SurveyAnswerCommentsButton',
});
</script>

<template>
    <div v-if="showButton">
        <InertiaLink
            :href="comments.url"
            :title="$tc('messages.X_comments', comments.comments_count, { count: comments.comments_count })"
        >
            <IconMessageFilled class="w-6 h-6 text-indigo-500" v-if="hasComments" />
            <IconMessage class="w-6 h-6 text-gray-400" v-else />
        </InertiaLink>
    </div>
    <div v-else>
        <IconMessageFilled class="w-6 h-6 text-indigo-500" v-if="hasComments" />
        <IconMessage class="w-6 h-6 text-gray-200" v-else />
    </div>
</template>
